import type { User } from '@rundown/types';
import { SectionCard } from '../SectionCard';

/**
 * Read-only identity. `UpdateUserAttributesDTO` (`PUT /auth/profile`) exists in
 * nauth and could edit name/phone/etc. later, but changing it is out of scope
 * for this round — this section only surfaces what Account → Security asked
 * for: showing who the screen belongs to.
 */
export function ProfileSection({ user }: { user: User }) {
  return (
    <SectionCard title="Profile">
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 fs-13">
        <dt className="text-muted">Name</dt>
        <dd className="text-ink">{user.name}</dd>
        <dt className="text-muted">Email</dt>
        <dd className="text-ink">{user.email}</dd>
      </dl>
    </SectionCard>
  );
}
